import $ from 'jquery'
import { clickLinkEvent } from 'application/ga_click_link_event'

export function initSlideshow(options = {}) {
  const $slideshow = options.slideshow || $('.slideshow');

  if ($slideshow.length) {
    $slideshow.on('init', function(slick){
      setImageClass(slick)
    })

    $slideshow.slick({
      dots: true,
      infinite: true,
      adaptiveHeight: true,
      focusOnChange: true,
      lazyLoad: 'progressive'
    });

    $slideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      let text = ''

      if (currentSlide > nextSlide) {
        text = 'previous slide'
      } else if (currentSlide < nextSlide) {
        text = 'next slide'
      }

      const gaDataClickLink = {
        module_name: 'slick',
        click_text: text,
        link_url: '',
        link_type: 'slick arrow'
      }

      clickLinkEvent(gaDataClickLink)
    });
  }
}

function setImageClass(slick) {
  const $paragraphs = $(slick.target).find('.slick-slide:not(.slick-cloned)').find('p');

  $paragraphs.each((index, paragraph) => {
    if ($(paragraph).text().trim().length && $(paragraph).has("img").length) {
      $(paragraph).addClass("with-image-and-text")
    }
  })
}
